export const setNewItem = (new_item) => ({
    type : 'SET_NEW_ITEM',
    payload : new_item,
})
